import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SidebarProvider } from "@/components/ui/sidebar";
import { SplashScreen } from "@/components/auth/SplashScreen";
import { Toaster } from "@/components/ui/toaster";

const queryClient = new QueryClient();

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={<SplashScreen />} persistor={persistor}>
          <TooltipProvider>
            <SidebarProvider>
              {children}
              <Toaster />
            </SidebarProvider>
          </TooltipProvider>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  );
}